import { Grid } from "@mui/material"
import { Identity } from "./_identity"
import { IdentityFront } from "./_identityFront"
import { IdentityBack } from "./_identityBack"

export const InfoIdentity = () => {
    return (
        <Grid container spacing={2}>
            <Grid xs={6} sm={6} md={6} lg={6} item>
                <Identity />
            </Grid>
            <Grid xs={6} sm={6} md={6} lg={6} item>
            </Grid>
            <Grid xs={6} sm={6} md={6} lg={6} item>
                <IdentityFront />
            </Grid>
            <Grid xs={6} sm={6} md={6} lg={6} item>
                <IdentityBack />
            </Grid>
        </Grid>
    )
}